import React from 'react'
import PropTypes from 'prop-types'
import { Flex, HStack } from '@chakra-ui/react'

function CardList({
  height = '100%',
  direction = 'row',
  children,
  justify,
  gap,
}) {
  if (direction === 'row') {
    return (
      <HStack
        w="100%"
        wrap="wrap"
        justifyContent={justify || 'space-between'}
        spacing={0}
        gap={gap}
      >
        {children}
      </HStack>
    )
  }
  return (
    <Flex h={height} w="100%" direction={direction}>
      {children}
    </Flex>
  )
}

CardList.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string,
  height: PropTypes.string,
  justify: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default CardList
